import './App.css';
import * as React from "react";
import Intro from "./page/Intro"
import VersionPick from "./page/VersionPick"
import MountingPick from "./page/MountingPick"
import RotatingPick from "./page/RotatingPick"
import SuspensionPick from "./page/SuspensionPick"
import ClosingPick from "./page/ClosingPick"
import FastenerPick from "./page/FastenerPick"
import Result from "./page/Result";
import {Convert} from "./Converter";
import * as jsPDF from "jspdf";
import {createHeaders} from "./PDFUtil";
import logo from './images/black-logo-with-text.png'

const Page = {
    Intro: 1,
    VersionPick: 2,
    MountingPick: 3,
    RotatingPick: 4,
    SuspensionPick: 5,
    ClosingPick: 6,
    FastenerPick: 7,
    Result: 8,
}

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: Page.Intro,
            VersionPick: null,
            MountingPick: null,
            RotatingPick: null,
            SuspensionPick: null,
            ClosingPick: null,
            FastenerPick: null,
            AddedToCart: 0,
        };
    }

    handlePageChange = (val) => {
        switch (this.state.page) {
            case Page.Intro:
                break;
            case Page.VersionPick:
                this.setState({
                    VersionPick: val,
                    MountingPick: null,
                    RotatingPick: null,
                    SuspensionPick: null,
                    ClosingPick: null,
                    FastenerPick: null,
                    AddedToCart: 0,
                });
                break;
            case Page.MountingPick:
                this.setState({
                    MountingPick: val,
                    RotatingPick: null,
                    SuspensionPick: null,
                    ClosingPick: null,
                    FastenerPick: null,
                    AddedToCart: 0,
                });
                break;
            case Page.RotatingPick:
                this.setState({
                    RotatingPick: val,
                    SuspensionPick: null,
                    ClosingPick: null,
                    FastenerPick: null,
                    AddedToCart: 0,
                });
                break;
            case Page.SuspensionPick:
                this.setState({
                    SuspensionPick: val,
                    ClosingPick: null,
                    FastenerPick: null,
                    AddedToCart: 0,
                });
                break;
            case Page.ClosingPick:
                this.setState({
                    ClosingPick: val,
                    FastenerPick: null,
                    AddedToCart: 0,
                });
                break;
            case Page.FastenerPick:
                this.setState({
                    FastenerPick: val,
                    AddedToCart: 0,
                });
                break;
            default:
                console.error("Unknown page enum while updating page: " + this.state.page)
        }
    }

    handleNextPage = () => {
        this.setState((state) => {
            if (state.page >= Page.Result) {
                return ({
                    page: Page.Intro,
                    VersionPick: null,
                    MountingPick: null,
                    RotatingPick: null,
                    SuspensionPick: null,
                    ClosingPick: null,
                    FastenerPick: null,
                    AddedToCart: 0,
                });
            }
            return ({page: ++state.page});
        });
    }

    downloadPDF = (e) => {
        e.preventDefault();

        const picksHeaders = createHeaders([
            "VersionPick",
            "MountingPick",
            "RotatingPick",
            "SuspensionPick",
            "ClosingPick",
            "FastenerPick"
        ], [
            "Beslag uitvoering",
            "Montage type",
            "Draai type",
            "Heng type",
            "Luiksluiting",
            "Luikvastzetter"
        ], [
            60,
            50,
            50,
            50,
            50,
            115
        ]);

        const picksData = [{
            "VersionPick": this.state.VersionPick,
            "MountingPick": this.state.MountingPick,
            "RotatingPick": this.state.RotatingPick,
            "SuspensionPick": this.state.SuspensionPick.type + " " + (this.state.SuspensionPick?.fullVariant?.label ?? ""),
            "ClosingPick": this.state.ClosingPick,
            "FastenerPick": this.state.FastenerPick
        }];

        const headers = createHeaders([
            "PRODUCT_NUMMER",
            "PRODUCT",
            "AANTAL",
            "OPMERKING"
        ], [
            "PRODUCT NUMMER",
            "PRODUCT",
            "AANTAL",
            "OPMERKING"
        ], [
            50,
            150,
            40,
            135
        ]);
        const data = [];
        Convert(
            this.state.VersionPick,
            this.state.MountingPick,
            this.state.RotatingPick,
            this.state.SuspensionPick,
            this.state.ClosingPick,
            this.state.FastenerPick
        ).forEach(i => {
            data.push(Object.assign({}, {
                PRODUCT_NUMMER: i.id,
                PRODUCT: i.name,
                AANTAL: "" + i.amount,
                OPMERKING: i.remark ? i.remark : "-"
            }));
        });

        const doc = new jsPDF.jsPDF({putOnlyUsedFonts: true, orientation: "landscape"});
        doc.addImage(logo, "PNG", 8, 20, 62.5, 25);
        doc.setFontSize(16);
        doc.text("Keuze hulp is een hulpmiddel, u bent zelf verantwoordelijk voor het controleren van uw bestelling.", 8, 55);
        doc.table(8, 60, picksData, picksHeaders, {});
        doc.table(8, 90, data, headers, {});
        const d = new Date();
        doc.save(`KeuzeHulp ${('0' + d.getDate()).slice(-2)}-${('0' + (d.getMonth() + 1)).slice(-2)}-${d.getFullYear()} ${d.getHours()};${d.getMinutes()}`);
    }

    addToCart = (multiplier) => {
        if (this.state.AddedToCart) return;
        this.setState({AddedToCart: 1});
        const items = Convert(
            this.state.VersionPick,
            this.state.MountingPick,
            this.state.RotatingPick,
            this.state.SuspensionPick,
            this.state.ClosingPick,
            this.state.FastenerPick
        )
        fetch(`/api/cart/bulk`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(items.map(i => ({product: i.id, quantity: i.amount * multiplier})))
        })
            .then(() => window.location.reload())
            .catch(e => {
                console.error(e)
                //TODO show error
            })
    }

    handlePreviousPage = () => {
        this.setState((state) => ({page: --state.page}));
    }

    render() {
        let pageRender;
        switch (this.state.page) {
            case Page.Intro:
                pageRender = <Intro
                    handleNextPage={this.handleNextPage}
                />;
                break;
            case Page.VersionPick:
                pageRender = <VersionPick
                    handleNextPage={this.handleNextPage}
                    handlePreviousPage={this.handlePreviousPage}
                    handlePageChange={this.handlePageChange}
                    currentValue={this.state.VersionPick}
                />;
                break;
            case Page.MountingPick:
                pageRender = <MountingPick
                    handleNextPage={this.handleNextPage}
                    handlePreviousPage={this.handlePreviousPage}
                    handlePageChange={this.handlePageChange}
                    currentValue={this.state.MountingPick}
                />
                break;
            case Page.RotatingPick:
                pageRender = <RotatingPick
                    handleNextPage={this.handleNextPage}
                    handlePreviousPage={this.handlePreviousPage}
                    handlePageChange={this.handlePageChange}
                    currentValue={this.state.RotatingPick}
                />
                break;
            case Page.SuspensionPick:
                pageRender = <SuspensionPick
                    handleNextPage={this.handleNextPage}
                    handlePreviousPage={this.handlePreviousPage}
                    handlePageChange={this.handlePageChange}
                    currentValue={this.state.SuspensionPick}
                />
                break;
            case Page.ClosingPick:
                pageRender = <ClosingPick
                    handleNextPage={this.handleNextPage}
                    handlePreviousPage={this.handlePreviousPage}
                    handlePageChange={this.handlePageChange}
                    currentValue={this.state.ClosingPick}
                />
                break;
            case Page.FastenerPick:
                pageRender = <FastenerPick
                    handleNextPage={this.handleNextPage}
                    handlePreviousPage={this.handlePreviousPage}
                    handlePageChange={this.handlePageChange}
                    currentValue={this.state.FastenerPick}
                    closingValue={this.state.ClosingPick}
                />
                break;
            case Page.Result:
                pageRender = <Result
                    handleNextPage={this.handleNextPage}
                    handlePreviousPage={this.handlePreviousPage}
                    addToCart={this.addToCart}
                    downloadPDF={this.downloadPDF}
                    addedToCart={this.state.AddedToCart}
                    productList={Convert(
                        this.state.VersionPick,
                        this.state.MountingPick,
                        this.state.RotatingPick,
                        this.state.SuspensionPick,
                        this.state.ClosingPick,
                        this.state.FastenerPick
                    )}
                    VersionPick={this.state.VersionPick}
                    MountingPick={this.state.MountingPick}
                    RotatingPick={this.state.RotatingPick}
                    SuspensionPick={this.state.SuspensionPick}
                    ClosingPick={this.state.ClosingPick}
                    FastenerPick={this.state.FastenerPick}
                />
                break;
            default:
                console.error("Unknown page enum: " + this.state.page)
                return <p>Er is helaas iets verkeerd gegaan. Herlaad de pagina of neem contact op.</p>
        }
        return (
            <div className="app">
                {pageRender}
            </div>
        );
    }
}

export default App;
